import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
        //flexBasis: '100%',
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: `45px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `80%`,
        },
      },
    icon: {
        [theme.breakpoints.up('xs')]: {
           minWidth: '56px'
        },
        [theme.breakpoints.up('sm')]: {
            width: `40%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `24%`,
        },
    },
  }));

const StandardAccordion = props => {
    const { title, expanded, onChange, children, defaultExpanded, png, pngPath, subtitle} = props
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Accordion  expanded = {expanded} defaultExpanded = {defaultExpanded} onChange= {onChange} >
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                >
                    {
                        png &&
                        <div className={classes.icon} >
                            <img src={pngPath} alt="Logo" className={classes.logo}  /> 
                        </div>
                    }
                    
                    <Typography className={classes.heading}>
                        {title}
                        <br/>
                        {subtitle}
                    </Typography>
                    
                </AccordionSummary>
                <AccordionDetails>
                    {children}
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

StandardAccordion.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
};

export default StandardAccordion;